module.exports = __webpack_public_path__ + "static/img/lymphomap.4ca179ee.png";